var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58173 16 0 12.4183 0 8C0 3.58173 3.58173 0 8 0C12.4183 0 16 3.58173 16 8ZM8.00009 14.8175C11.7653 14.8175 14.8176 11.7652 14.8176 7.99999C14.8176 4.23481 11.7653 1.18253 8.00009 1.18253C4.2349 1.18253 1.18262 4.23481 1.18262 7.99999C1.18262 11.7652 4.2349 14.8175 8.00009 14.8175Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99957 5.43646C7.79362 5.43646 7.61818 5.36648 7.47325 5.22652C7.32832 5.08655 7.25586 4.91713 7.25586 4.71823C7.25586 4.51934 7.32832 4.34991 7.47325 4.20994C7.61818 4.06998 7.79362 4 7.99957 4C8.21314 4 8.38858 4.06998 8.52588 4.20994C8.67081 4.34991 8.74327 4.51934 8.74327 4.71823C8.74327 4.91713 8.67081 5.08655 8.52588 5.22652C8.38858 5.36648 8.21314 5.43646 7.99957 5.43646Z",
    fill: "#4E4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59127 7.01083H7.40918V12H8.59127V7.01083Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.1780f514f8289711c41beadde2fbbad9.svg";
export { ForwardRef as ReactComponent };